import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/eye-off.svg'
import _imports_1 from '@/assets/external-link.svg'


const _hoisted_1 = { class: "profile-details profile-details-dropdown" }
const _hoisted_2 = {
  key: 0,
  style: {"height":"100px","width":"100%"}
}
const _hoisted_3 = {
  key: 1,
  class: "pro-details-box"
}
const _hoisted_4 = { class: "property-label" }
const _hoisted_5 = {
  key: 2,
  class: "pro-details-box"
}
const _hoisted_6 = { class: "property-label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 3,
  class: "pro-details-box"
}
const _hoisted_9 = { class: "property-label" }
const _hoisted_10 = {
  key: 4,
  class: "pro-details-box"
}
const _hoisted_11 = { class: "property-label" }
const _hoisted_12 = { class: "truncate-text" }
const _hoisted_13 = { class: "pro-details-box" }
const _hoisted_14 = { class: "property-label" }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Filtered Dataset"
}, null, -1)
const _hoisted_18 = { class: "pro-details-box" }
const _hoisted_19 = { class: "property-label" }
const _hoisted_20 = ["href", "title"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid external-link",
  src: _imports_1,
  alt: "External link"
}, null, -1)
const _hoisted_22 = { class: "url-link view-more-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainPredicates, (triple, tripleIndex) => {
        return (_openBlock(), _createElementBlock("li", { key: tripleIndex }, [
          (triple.predicate == 'latAndLong')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_l_map, {
                  ref_for: true,
                  ref: "dropdown-map",
                  id: "dropdown-map",
                  zoom: _ctx.zoom,
                  "onUpdate:zoom": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.zoom) = $event)),
                  center: triple.object,
                  options: {
                            dragging: false,
                            zoomControl: false,
                            scrollWheelZoom: false,
                            doubleClickZoom: false,
                            boxZoom: false,
                            attributionControl: false,
                        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_l_tile_layer, {
                      url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
                      "layer-type": "base",
                      attribution: "Tiles © Esri"
                    }),
                    _createVNode(_component_l_marker, {
                      "lat-lng": triple.object
                    }, null, 8, ["lat-lng"])
                  ]),
                  _: 2
                }, 1032, ["zoom", "center"])
              ]))
            : _createCommentVNode("", true),
          (triple.predicate == 'has note')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("EntityDetailsDropdown.summary")), 1),
                _createElementVNode("p", null, _toDisplayString(triple.object), 1)
              ]))
            : _createCommentVNode("", true),
          (triple.predicate == 'Dates')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("EntityDetailsDropdown.dates")), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("EntityDetailsDropdown.birth")) + ": " + _toDisplayString(triple["birthDate"] ?? "Unknown") + ", " + _toDisplayString(triple["birthPlace"] ?? "Unknown") + " ", 1),
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("EntityDetailsDropdown.death")) + ": " + _toDisplayString(triple["deathDate"] ?? "Unknown") + ", " + _toDisplayString(triple["deathPlace"] ?? "Unknown"), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (triple.predicate == 'Created')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("EntityDetailsDropdown.created")), 1),
                _createElementVNode("p", null, _toDisplayString(triple["createDate"] ?? "Unknown") + ", " + _toDisplayString(triple["createPlace"] ?? "Unknown"), 1)
              ]))
            : _createCommentVNode("", true),
          (
                        triple.predicate == 'pursuit' ||
                        triple.predicate == 'attribute' ||
                        triple.predicate == 'work' ||
                        triple.predicate == 'bornHere' ||
                        triple.predicate == 'diedHere' ||
                        triple.predicate == 'type' ||
                        triple.predicate == 'member' ||
                        triple.predicate == 'group' ||
                        triple.predicate == 'published' ||
                        triple.predicate == 'creator'
                    )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("EntityDetailsDropdown." + triple.predicate.replaceAll(' ', '_'))), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(triple.object), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("EntityDetailsDropdown.dataset")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasets, (dataset, datasetUri) => {
          return (_openBlock(), _createElementBlock("div", { key: datasetUri }, [
            (_ctx.disableDatasetFilters || _ctx.datasetsToDisplay.includes(datasetUri))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "truncate-text",
                  title: dataset.name ?? datasetUri
                }, _toDisplayString(dataset.name ?? datasetUri), 9, _hoisted_15))
              : _createCommentVNode("", true),
            (!_ctx.disableDatasetFilters && _ctx.datasetsToHide.includes(datasetUri))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "truncate-text hidden-dataset",
                  title: dataset.name ?? datasetUri
                }, [
                  _createTextVNode(_toDisplayString(dataset.name ?? datasetUri) + " ", 1),
                  _hoisted_17
                ], 8, _hoisted_16))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("li", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("EntityDetailsDropdown.identifier")), 1),
        _createElementVNode("a", {
          class: "url-link truncate-text",
          href: _ctx.data.mainEntityInfo.resource,
          target: "_blank",
          title: _ctx.data.mainEntityInfo.resource
        }, [
          _createTextVNode(_toDisplayString(_ctx.data.mainEntityInfo.resource), 1),
          _hoisted_21
        ], 8, _hoisted_20)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "pro-details-box view-more-button",
          tabindex: "0",
          role: "link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update')))
        }, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("EntityDetailsDropdown.view_more")), 1)
        ])
      ])
    ])
  ]))
}